import { useEffect, useState } from "react";
import { subscribeToasts, dismissToast, type ToastMsg } from "../toast.js";

/** Einmal in App.tsx gerendert – zeigt den aktuellen Toast-Stapel unten rechts. */
export default function ToastHost() {
  const [items, setItems] = useState<ToastMsg[]>([]);

  useEffect(() => subscribeToasts(setItems), []);

  if (items.length === 0) return null;

  return (
    <div className="toast-stack">
      {items.map((t) => (
        <div key={t.id} className={`toast toast-${t.kind}`} onClick={() => dismissToast(t.id)}>
          {t.text}
        </div>
      ))}
    </div>
  );
}
